import {
  ACTIVITIES_FONT_1_2,
  ACTIVITIES_FONT_3_4,
  ACTIVITIES_FONT_5_6,
  ACTIVITIES_FONT_K,
  ActivitiesFontSize,
} from 'global/constants';
import { ActivityBuilderTheme } from './activity-builder-theme.constants';

export function getFontSizesFromBase(size: ActivitiesFontSize): {
  medium: {
    size: ActivitiesFontSize;
    lineHeight: number;
  };
  small: {
    size: number;
    lineHeight: number;
  };
} {
  switch (size) {
    case ACTIVITIES_FONT_K:
      return {
        medium: {
          size: 30,
          lineHeight: 42,
        },
        small: {
          size: 28,
          lineHeight: 40,
        },
      };
    case ACTIVITIES_FONT_1_2:
      return {
        medium: {
          size: 28,
          lineHeight: 40,
        },
        small: {
          size: 24,
          lineHeight: 34,
        },
      };
    case ACTIVITIES_FONT_3_4:
      return {
        medium: {
          size: 22,
          lineHeight: 32,
        },
        small: {
          size: 20,
          lineHeight: 30,
        },
      };
    case ACTIVITIES_FONT_5_6:
      return {
        medium: {
          size: 20,
          lineHeight: 30,
        },
        small: {
          size: 18,
          lineHeight: 28,
        },
      };
    default:
      return {
        medium: {
          size: 30,
          lineHeight: 42,
        },
        small: {
          size: 28,
          lineHeight: 40,
        },
      };
  }
}

export function updateFontSize(
  baseSize: ActivitiesFontSize,
  theme: ActivityBuilderTheme
): ActivityBuilderTheme {
  return {
    ...theme,
    theming: {
      ...theme.theming,
      font: {
        ...getFontSizesFromBase(baseSize),
      },
    },
  };
}

export function getLineMinHeight(baseSize: number | undefined) {
  switch (baseSize) {
    case ACTIVITIES_FONT_K:
      return 58;
    case ACTIVITIES_FONT_1_2:
      return 52;
    case ACTIVITIES_FONT_3_4:
      return 48;
    case ACTIVITIES_FONT_5_6:
      return 46;
    default:
      return 72;
  }
}
